import React from "react";
import HeroCarousel from "./HeroCarousel";

const HeroSection = () => (
  <section className="relative bg-gradient-to-b from-btn-primary to-btn-secondary-base text-white py-8 px-2 sm:py-24 sm:px-4 text-center overflow-hidden">
    <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center gap-10">
      <div className="flex-1 flex flex-col items-center md:items-start text-center md:text-left mt-12 md:mt-0">
        <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-4 sm:mb-6 text-btn-primary-text drop-shadow-lg">
        <span className="text-btn-secondary">Cash Canvas</span> 
          All-in-one Financial Management App for Smart Money Moves
        </h1>
        <p className="text-base sm:text-lg md:text-2xl mb-6 sm:mb-8 text-btn-primary-text">
          Import or manually add your income, expenses, savings, debts, and investments in one place.
          Then,  use CashBot to create personal and customized AI insights to help you budget smarter, save more, and grow your wealth with confidence.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center w-full">
          <a
            href="/signup"
            className="inline-block bg-btn-secondary text-btn-secondary-text font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-btn-secondary-hover transition text-center w-full sm:w-auto"
          >
            Get Started
          </a>
          <a
            href="/about-us"
            className="inline-block border-2 border-btn-secondary text-btn-secondary-text font-semibold px-8 py-3 rounded-full hover:bg-btn-secondary-hover hover:text-btn-primary transition text-center w-full sm:w-auto"
          >
            Learn More
          </a>
        </div>
      </div>
      <div className="flex-1 flex justify-center w-full md:mt-20 mt-0 mb-8 md:mb-0">
        <div className="w-full max-w-xs sm:max-w-sm md:max-w-md">
          <HeroCarousel />
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
